import { WindowLocationWrapper } from "../window_wrapping/WindowLocationWrapper";
import { DocumentWrapper } from "./DocumentWrapper";

export class DefaultDocumentWrapper implements DocumentWrapper {
	constructor(private _windowLocation: WindowLocationWrapper) {
		// intentionally left empty
	}

	get title(): string {
		return document.title;
	}

	get windowLocation(): WindowLocationWrapper {
		return this._windowLocation;
	}
}
